import autoComplete from "../../../components/autocomplete/client.js";

(function () {
  const endpoint = "https://secure.money.com/";
  const onSelection = function (dataset) {
    if (dataset && dataset.value) {
      const {
        key
      } = dataset;
      const url = endpoint + "car-insurance/lp/compare-car-insurance";
      window.location.href = `${url}?company=${key}`;
    }
  }

  function initTrellisInsuranceData() {
    const xhr = new XMLHttpRequest();
    const url = endpoint + "trellis_issuers";
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-type', 'application/json');
    xhr.onload = function () {
      if (this.status >= 200 && this.status < 400) {
        try {
          const response = JSON.parse(this.responseText);
          var insuranceData = response.data.getIssuers;
          insuranceData = insuranceData.map((d) => {
            var item = {
              id: d.id,
              name: d.name,
              value: d.site
            };
            return item;
          });
          // Init autoComplete component
          new autoComplete({
            data: insuranceData,
            onSelection: onSelection
          });
        } catch (e) {
          console.log('Result Error, Please try again or contact us if you keep running into this error.', e);
        }
      }
    };
    xhr.onerror = function (e) {
      console.log('Request Error, Please try again or contact us if you keep running into this error.', e)
    }
    xhr.send();
  }

  initTrellisInsuranceData();
})();